import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["source", "selected", "hiddenFields"]

  connect() {
    this.draggedItem = null
  }

  dragStart(event) {
    this.draggedItem = event.target.closest('[data-destination-id]')
    this.draggedItem.classList.add('dragging')
    event.dataTransfer.effectAllowed = 'move'
  }

  dragEnd(event) {
    if (this.draggedItem) {
      this.draggedItem.classList.remove('dragging')
      this.draggedItem = null
    }
    this.updateHiddenFields()
  }

  dragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'move'
    
    const afterElement = this.getDragAfterElement(event.clientY)
    if (afterElement == null) {
      this.selectedTarget.appendChild(this.draggedItem)
    } else {
      this.selectedTarget.insertBefore(this.draggedItem, afterElement)
    }
  }

  getDragAfterElement(y) {
    const draggableElements = [...this.selectedTarget.querySelectorAll('[data-destination-id]:not(.dragging)')]
    
    return draggableElements.reduce((closest, child) => {
      const box = child.getBoundingClientRect()
      const offset = y - box.top - box.height / 2
      if (offset < 0 && offset > closest.offset) {
        return { offset: offset, element: child }
      } else {
        return closest
      }
    }, { offset: Number.NEGATIVE_INFINITY }).element
  }

  add(event) {
    event.preventDefault()
    const select = this.sourceTarget
    const selectedOption = select.options[select.selectedIndex]
    
    if (!selectedOption || selectedOption.value === "") return
    
    const destinationId = selectedOption.value
    const destinationName = selectedOption.text
    
    if (this.isAlreadySelected(destinationId)) {
      return
    }
    
    const listItem = this.createListItem(destinationId, destinationName)
    this.selectedTarget.appendChild(listItem)
    
    select.selectedIndex = 0
    
    this.updateHiddenFields()
  }

  remove(event) {
    event.preventDefault()
    const listItem = event.target.closest('[data-destination-id]')
    if (listItem) {
      listItem.remove()
      this.updateHiddenFields()
    }
  }

  isAlreadySelected(destinationId) {
    return this.selectedTarget.querySelector(`[data-destination-id="${destinationId}"]`) !== null
  }

  createListItem(destinationId, destinationName) {
    const li = document.createElement('li')
    li.className = 'list-group-item d-flex justify-content-between align-items-center'
    li.dataset.destinationId = destinationId
    li.draggable = true
    li.dataset.action = 'dragstart->sortable-destinations#dragStart dragend->sortable-destinations#dragEnd'
    
    li.innerHTML = `
      <span class="drag-handle mr-2" style="cursor: grab;">☰</span>
      <span class="destination-name flex-grow-1">${destinationName}</span>
      <button type="button" class="btn btn-sm btn-danger" data-action="sortable-destinations#remove">✕</button>
    `
    
    return li
  }

  updateHiddenFields() {
    this.hiddenFieldsTarget.innerHTML = ''
    
    const items = this.selectedTarget.querySelectorAll('[data-destination-id]')
    items.forEach((item, index) => {
      const destinationId = item.dataset.destinationId
      const sequenceNumber = index + 1
      
      const idField = document.createElement('input')
      idField.type = 'hidden'
      idField.name = `takeout[takeout_destinations_attributes][${index}][destination_id]`
      idField.value = destinationId
      
      const sequenceField = document.createElement('input')
      sequenceField.type = 'hidden'
      sequenceField.name = `takeout[takeout_destinations_attributes][${index}][sequence_number]`
      sequenceField.value = sequenceNumber
      
      this.hiddenFieldsTarget.appendChild(idField)
      this.hiddenFieldsTarget.appendChild(sequenceField)
    })
  }

  get selectedDestinationIds() {
    const items = this.selectedTarget.querySelectorAll('[data-destination-id]')
    return Array.from(items).map(item => item.dataset.destinationId)
  }
}
